module.exports = __webpack_public_path__ + "static/media/citymusic.01365088.ogg";